import { c as _c } from "react/compiler-runtime";
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { formatDateShort } from '@/app/utils/format';
export interface DateProps {
  startDate: Date | string | null;
  endDate?: Date | string | null;
}
export interface DateFullProps {
  className?: string;
  date: DateProps;
  untilText?: string | boolean;
}
const DEFAULT_UNTIL_TEXT = 'เป็นต้นไป';
export const DateFull = t0 => {
  const $ = _c(12);
  const {
    className,
    date: t1,
    untilText: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {
      startDate: null,
      endDate: null
    } : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const date = t3;
  const untilText = t2 === undefined ? false : t2;
  const {
    startDate,
    endDate
  } = date;
  const t4 = startDate || "";
  let t5;
  if ($[2] !== t4) {
    t5 = formatDateShort(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let dateText = t5;
  if (endDate) {
    const t6 = dateText;
    const t7 = endDate || "";
    let t8;
    if ($[4] !== t7) {
      t8 = formatDateShort(t7);
      $[4] = t7;
      $[5] = t8;
    } else {
      t8 = $[5];
    }
    dateText = `${t6} - ${t8}`;
  } else {
    if (untilText) {
      const text = typeof untilText === "string" ? untilText : DEFAULT_UNTIL_TEXT;
      dateText = `${dateText} ${text}`;
    }
  }
  let t6;
  if ($[6] !== className) {
    t6 = cn("text-body-1-fixed block text-gray-600", className);
    $[6] = className;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = createDataAttributes({
      test: "date"
    });
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== dateText || $[10] !== t6) {
    t8 = <span className={t6} {...t7}>{dateText}</span>;
    $[9] = dateText;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};